import React from "react"
import {Box, Paper, Typography} from "@mui/material";
import WalletIcon from "../layout/WalletIcon";
import "./Wallet.css"
import WalletBalance from "../layout/WalletBalance";


const Wallet = ({walletBalance, onWalletClick}) => {

    return <Paper elevation={10} sx={{borderRadius: "1rem", display: "inline-block"}} onClick={event => {onWalletClick(walletBalance); event.stopPropagation()}} className="wallet">
        <Box sx={{width: "100%", height: 60, borderRadius: "1rem 1rem 0 0", position: "relative"}}
             bgcolor="primary.light">
            <Typography variant="h3"
                        sx={{fontSize: 20, fontWeight: 600, position: "absolute", opacity: "0.8", left: 15, top: 12, maxWidth: "80%"}}
                        color="primary.contrastText"
                        noWrap={true}
            >{walletBalance.name}</Typography>
            <WalletIcon image={walletBalance.image} sx={{position: "absolute", right: 10, top: 10}}/>
        </Box>
        <Box sx={{width: "100%", borderRadius: "0 0 1rem 1rem", position: "relative"}}
             bgcolor="secondary.main"
             className="walletBalanceBox">
            <Typography sx={{fontSize: 20, fontWeight: 600, position: "absolute", right: "10px", left: "10px", textAlign: "right", bottom: "2px"}}
                        noWrap={true}
                        className="walletBalance"
                        color="secondary.contrastText"><WalletBalance wallet={walletBalance}/></Typography>
        </Box>
    </Paper>
}

export default Wallet